import axios from 'axios'
import { useMetaStore } from '../../scoring/store/MetaStore'

const apiClient = axios.create()

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('g-oauth-token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      useMetaStore.getState().setErrorMsg('You are not authorized to perform that action.')
      window.location.href = '/error'
    }
    return Promise.reject(error)
  }
)

export default apiClient
